import { useState } from 'react';
import { Pencil, Ban } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import type { ContaCorrente } from '../types';

interface Props {
  contas: ContaCorrente[];
  onEdit: (conta: ContaCorrente) => void;
  onInativar: (id: number) => void;
}

export const ContasCorrentesTable = ({ contas, onEdit, onInativar }: Props) => {
  const [inativarId, setInativarId] = useState<number | null>(null);

  return (
    <div className="space-y-4">
      <div className="border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Descrição</TableHead>
              <TableHead>Número da Conta</TableHead>
              <TableHead>Agência</TableHead>
              <TableHead>Chave PIX</TableHead>
              <TableHead className="text-center">Status</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {contas.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-muted-foreground py-8">
                  Nenhuma conta corrente cadastrada
                </TableCell>
              </TableRow>
            ) : (
              contas.map((conta) => (
                <TableRow key={conta.id}>
                  <TableCell className="font-medium">{conta.descricao}</TableCell>
                  <TableCell className="font-mono">{conta.numeroConta || '-'}</TableCell>
                  <TableCell>{conta.codigoAgencia || '-'}</TableCell>
                  <TableCell className="max-w-xs truncate">{conta.chavePix || '-'}</TableCell>
                  <TableCell className="text-center">
                    <Badge variant={conta.isAtivo ? 'success' : 'secondary'}>
                      {conta.isAtivo ? 'Ativa' : 'Inativa'}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-1">
                      <Button variant="ghost" size="icon" onClick={() => onEdit(conta)}>
                        <Pencil className="h-4 w-4" />
                      </Button>
                      {conta.isAtivo && (
                        <Button variant="ghost" size="icon" onClick={() => setInativarId(conta.id)}>
                          <Ban className="h-4 w-4" />
                        </Button>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>

      <AlertDialog open={!!inativarId} onOpenChange={() => setInativarId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Inativar conta corrente</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja inativar esta conta corrente?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={() => { if (inativarId) { onInativar(inativarId); setInativarId(null); } }}>
              Inativar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
